import React, { useEffect, useState } from 'react';
import {
  Box, Button, Typography, Grid, MenuItem, Autocomplete,
} from '@mui/material';
import {
  Breadcrumb, Cancel, CTSinput,
} from '../../reusableComponent/Reusables';
import { useLocation, useNavigate } from 'react-router-dom';
import SaveIcon from '@mui/icons-material/Save';
import styles from '../../../styles.module.css';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import customerMasterService from '../../../services/masters/customerMaster.Service';
import productMasterService from '../../../services/masters/productMaster.Service';
import openingbalanceService from '../../../services/report/openingbalaance.Service';
import ReusableSnackbar from '../../reusableComponent/ReusableSnackbar';

const OpeningBalance = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state || {};

  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details || '{}');
  const userInfo = userD.result?.userInfo || {};
  const depot_id = userInfo.depot_id || '';
  const unit_id = userInfo.depot_id || userInfo.plant_id || '';
  const short_code = userInfo.depot_short_code || userInfo.plant_short_code || '';
  const user_id = userInfo.user_id || '';
  const assigned_plant_id = userInfo.assigned_plant_id || '';

  const [successMessage, setSuccessMessage] = useState('');
  const [warningMessage, setWarningMessage] = useState('');
  const [customer, setCustomer] = useState([]);
  const [product, setProduct] = useState([]);
  const [loading, setLoading] = useState(true);

  const initialData = {
    entry_id: editData.entry_id || null,
    entry_no: editData.entry_no || '',
    entry_date: editData.entry_date ? dayjs(editData.entry_date) : dayjs(),
    customer_id: editData.customer_id || '',
    customer_name: editData.customer_name || '',
    product_id: editData.product_id || '',
    opening_balance: editData.opening_balance || '',
    balance_type: editData.balance_type || '',
    from_depot_id: depot_id || '',
  };

  const [data, setData] = useState(initialData);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const [customerResponse, productResponse] = await Promise.all([
          customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: '' }),
          productMasterService.getProductList({ page: 0, size: 999, searchKey: '' }),
        ]);

        const customerData = Array.isArray(customerResponse.data) ? customerResponse.data : customerResponse || [];
        const productData = Array.isArray(productResponse.data) ? productResponse.data : productResponse || [];

        setCustomer(customerData);
        setProduct(productData);
        console.log('Customer Data:', customerData);
        console.log('Product Data:', productData);
      } catch (error) {
        console.error('Error fetching data:', error);
        setWarningMessage('Error fetching customer or product data.');
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validatePayload = (payload) => {
    const requiredFields = ['customer_id', 'product_id', 'entry_no', 'entry_date', 'opening_balance'];
    const missingFields = requiredFields.filter(field => !payload[field] || payload[field] === '');
    return missingFields.length === 0 ? null : missingFields;
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!data.from_depot_id && !userInfo.plant_id) {
      setWarningMessage('Cannot submit: No valid depot or plant assigned.');
      return;
    }

    if (!assigned_plant_id) {
      setWarningMessage('Cannot submit: No assigned plant.');
      return;
    }

    const payload = {
      ...data,
      entry_no: data.entry_no,
      entry_date: dayjs(data.entry_date).isValid() ? dayjs(data.entry_date).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD'),
      modified_at: editData.entry_id ? dayjs().format('YYYY-MM-DD HH:mm:ss') : null,
      modified_by: editData.entry_id ? user_id : null,
      created_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      created_by: user_id,
      short_code,
      unit_id,
    };

    console.log('Payload before submission:', payload);
    try {
      if (editData.entry_id) {
        await openingbalanceService.editdeleteOpningBaalncereport(payload);
        setSuccessMessage('Opening balance updated successfully.');
      } else {
        await openingbalanceService.addOpningBaalncereport(payload);
        setSuccessMessage('Opening balance created successfully.');
      }

      setTimeout(() => navigate(-1), 2000);
    } catch (error) {
      console.error('Save error:', error);
      setWarningMessage('Error saving opening balance.');
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box className={styles.cts_page}>
        <Box className={styles.body}>
          <Breadcrumb routeSegments={[{ name: 'Opening Balance' }]} />

          <Box sx={{ display: 'flex' }}>
            <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
              <Grid item md={7}>
                <Typography className={styles.header_txt}>OPENING BALANCE ENTRY</Typography>
              </Grid>
            </Grid>
          </Box>

          {loading && <Typography>Loading data...</Typography>}

          <form onSubmit={onSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Grid container spacing={1}>
                  {/* Customer Autocomplete */}
                  <Grid item xs={12} sm={6}>
                    <Typography className={styles.label_Txt}>Customer</Typography>
                    <Autocomplete
                      disablePortal
                      disabled={loading}
                      options={customer}
                      getOptionLabel={(option) => option.cust_name || option.customer_name || ''}
                      value={customer.find((c) => c.cust_id === data.customer_id) || null}
                      onChange={(event, newValue) => {
                        setData((prev) => ({
                          ...prev,
                          customer_id: newValue?.cust_id ?? '',
                          customer_name: newValue?.cust_name || newValue?.customer_name || '',
                        }));
                      }}
                      isOptionEqualToValue={(option, value) => option.cust_id === value?.cust_id}
                      renderOption={(props, option) => (
                        <MenuItem {...props} className={styles.cts_lable}>
                          {option.cust_name || option.customer_name || 'Unknown Customer'}
                        </MenuItem>
                      )}
                      renderInput={(params) => (
                        <CTSinput
                          {...params}
                          variant="outlined"
                          size="small"
                          fullWidth
                          InputProps={{
                            ...params.InputProps,
                            className: styles.CTSinput_Box,
                          }}
                        />
                      )}
                    />
                  </Grid>

                  {/* Product Select */}
                  <Grid item xs={12} sm={6}>
                    <Typography className={styles.label_Txt}>Product</Typography>
                    <CTSinput
                      select
                      fullWidth
                      size="small"
                      name="product_id"
                      value={data.product_id || ''}
                      onChange={handleChange}
                      InputProps={{ className: styles.CTSinput_Box }}
                      disabled={loading}
                    >
                      <MenuItem value="" disabled>
                        Select Product
                      </MenuItem>
                      {(product || []).map((p) => (
                        <MenuItem key={p.prod_id} value={p.prod_id} className={styles.cts_lable}>
                          {p.prod_code || 'Unknown Product'}
                        </MenuItem>
                      ))}
                    </CTSinput>
                  </Grid>

                  {/* Entry No */}
                  <Grid item xs={12} sm={6}>
                    <Typography className={styles.label_Txt}>Entry No</Typography>
                    <CTSinput
                      size="small"
                      fullWidth
                      name="entry_no"
                      value={data.entry_no}
                      onChange={handleChange}
                      InputProps={{
                        readOnly: true,
                        className: styles.CTSinput_Box,
                        style: { backgroundColor: '#f0f0f0' },
                      }}
                    />
                  </Grid>

                  {/* Opening Balance */}
                  <Grid item xs={12} sm={6}>
                    <Typography className={styles.label_Txt}>Opening Balance</Typography>
                    <CTSinput sauvage
                      size="small"
                      fullWidth
                      name="opening_balance"
                      value={data.opening_balance}
                      onChange={handleChange}
                      type="number"
                      InputProps={{ className: styles.CTSinput_Box }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Entry Date */}
              <Grid item xs={12} sm={6}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <Typography className={styles.label_Txt}>Entry Date</Typography>
                    <DatePicker
                      format="DD/MM/YYYY"
                      value={data.entry_date}
                      onChange={(newValue) =>
                        setData((prev) => ({
                          ...prev,
                          entry_date: newValue && newValue.isValid() ? newValue : dayjs(),
                        }))
                      }
                      slotProps={{
                        textField: {
                          size: 'small',
                          fullWidth: true,
                          required: true,
                          InputProps: {
                            className: styles.CTSinput_Box,
                            disableUnderline: true,
                          },
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Buttons */}
              <Grid item xs={12} className={styles.grid_input}>
                <Box className={styles.btn_container}>
                  <Button id={styles.btn_save} type="submit" disabled={loading}>
                    <SaveIcon className={styles.btn_cancel_txt} />
                    <Typography className={styles.btn_cancel_txt}>
                      {editData.entry_id ? 'Update' : 'Save'}
                    </Typography>
                  </Button>
                  <Button id={styles.btn_cancel} onClick={handleCancel} disabled={loading}>
                    <Cancel />
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>

          {/* Snackbar Notifications */}
          <ReusableSnackbar
            open={!! successMessage}
            onClose={(event, reason) => {
              if (reason !== 'clickaway') {
                setSuccessMessage('');
              }
            }}
            message={successMessage}
            autoHideDuration={2000}
            vertical="top"
            horizontal="right"
          />
          <ReusableSnackbar
            open={!!warningMessage}
            onClose={(event, reason) => {
              if (reason !== 'clickaway') {
                setWarningMessage('');
              }
            }}
            message={warningMessage}
            autoHideDuration={3000}
            vertical="top"
            horizontal="right"
          />
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default OpeningBalance;